import React, { useState } from 'react';
import Icon from '@visa/vds/icon';

const MCSSortableIcon = (props) => {
    
    const displayAscending = (props)=>{
        if(props.sortable && !props.dsc){;
            return {
                fill: "#1A1F71"
            }
        }else{
            return{
                fill: "#D7D7DE"
            }
        }
    }

    const displayDescending  = (props)=>{
        if(props.sortable && props.dsc){
            return {
                fill: "#1A1F71"
            }
        }else{
            return {
                fill: "#D7D7DE"
            }
        }
    }

    return(
        <>

        <div style={{display:"inline-flex"}}>
            <Icon name="sortable-ascending" resolution="tiny" style={displayAscending(props)} />
            <br/>
            <Icon name="sortable-descending" resolution="tiny" style={displayDescending(props)} />
        </div>


      </>
    );
}

export default MCSSortableIcon;